import { TFunction } from 'i18next';

import { formatMinMaxRange } from '@features/campaigns/builder/utils/calculateEstimatedReachFrequency';
import { formatNumberAsMoney } from '@shared/utils/moneyFormat';
import {
  formatNumbersAsCompactNumbers,
  formatNumberWithCommas,
  formatNumberWithMaxTwoDigitsAfterSeparator,
} from '@shared/utils/numberFormat';

interface FormatValueType {
  isMoneyValue: boolean;
  isBudgetCase: boolean;
  isTimeSpent: boolean;
  isFrequencyValue: boolean;
  isEngagementValue?: boolean;
  isActivationValue?: boolean;
  value?: number | string;
  valueRange?: number[];
  translationFn: TFunction<string, 'unknown'>;
}

export function formatValue({
  isMoneyValue,
  isBudgetCase,
  isTimeSpent,
  isFrequencyValue,
  isEngagementValue,
  isActivationValue,
  valueRange,
  value,
  translationFn,
}: FormatValueType): string {
  if (valueRange) {
    return formatMinMaxRange(valueRange[0], valueRange[1], true);
  }

  if (typeof value === 'undefined') {
    return '-';
  }

  if (typeof value === 'string') {
    return translationFn(value);
  }

  if (isMoneyValue) {
    return formatNumberAsMoney(value, isBudgetCase ? 0 : 2);
  }

  if (isFrequencyValue) {
    return formatNumberWithMaxTwoDigitsAfterSeparator(value);
  }

  if (isEngagementValue) {
    return formatNumbersAsCompactNumbers(value);
  }

  if (isActivationValue) {
    return `${formatNumberWithMaxTwoDigitsAfterSeparator(value)} %`;
  }

  if (isTimeSpent) {
    return `${formatNumbersAsCompactNumbers(value)} sec`;
  }

  return formatNumberWithCommas(value);
}
